import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { pickLocalized } from '../i18n/localizedText';
import { useDiscreet } from '../security/discreet';
import { DECOY_PATH } from '../security/panicExit';
import {
  ROBOTS_INDEX,
  ROBOTS_NOINDEX,
  formatDocumentTitle,
  resolveRouteMeta,
} from './routeMeta';

function setRobots(content: string): void {
  let tag = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
  if (!tag) {
    tag = document.createElement('meta');
    tag.name = 'robots';
    document.head.appendChild(tag);
  }
  tag.content = content;
}

/**
 * Keeps `document.title` and `meta[name=robots]` in step with the route.
 * Mount once inside the router. In discreet mode, and on the decoy notes
 * page, the title belongs to the tab disguise and is left alone.
 */
export default function PageMeta(): null {
  const { pathname } = useLocation();
  const { language } = useTranslation();
  const discreet = useDiscreet();

  useEffect(() => {
    const meta = resolveRouteMeta(pathname);
    setRobots(meta.indexable ? ROBOTS_INDEX : ROBOTS_NOINDEX);
    if (discreet || pathname === DECOY_PATH) return;
    document.title = formatDocumentTitle(
      meta.title ? pickLocalized(meta.title, language) : null,
      import.meta.env.VITE_APP_TITLE,
      language
    );
  }, [pathname, language, discreet]);

  return null;
}
